import { render, staticRenderFns } from "./radio-widget.vue?vue&type=template&id=6a54a6d2&scoped=true"
import script from "./radio-widget.vue?vue&type=script&lang=js"
export * from "./radio-widget.vue?vue&type=script&lang=js"
import style0 from "./radio-widget.vue?vue&type=style&index=0&id=6a54a6d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a54a6d2",
  null
  
)

export default component.exports